import './styles.scss';
import React from "react";

/* Types, Constants, Utils */
import {IViewerState} from "../../../types/redux/viewer";

/* Bootstrap*/
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";

/* Components */
import MetaFields from "../../cards/components/meta-fields";

const ViewerMetadata = ():JSX.Element => {
  const record: any = useSelector<RootState, IViewerState>(state => state.viewer).viewerRecord;
  return (record) ? (
    <div className={'viewer-metadata px-1 py-1 py-lg-2'}>
      <MetaFields
        record={record}
        setColumns={false}
        noFold={true}
      />
    </div>
  ) : <></>
}
export default ViewerMetadata;
